// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EpjJYmMTcqSWyPqIY3bU{--table-bottom-color:var(--border-neutral-default);--table-row-hover-color:transparent;flex-direction:column;align-items:flex-start;gap:20px;min-height:420px;margin-left:-4px;display:flex;container:container-root/inline-size}.EpjJYmMTcqSWyPqIY3bU td:nth-child(2){max-width:344px}@container container-root (width<=600px){.EpjJYmMTcqSWyPqIY3bU td:nth-child(2){max-width:260px}}.PjijXbpcH7kazN5NyF_9{margin:-16px -20px 16px}.FmHwacSXUTcQJGwJhf9u{align-items:center;width:100%;height:32px;display:flex}.wsLrdTGGFwgS0_wn9OoM{align-items:center;gap:8px;margin-left:auto;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `EpjJYmMTcqSWyPqIY3bU`,
	"alert": `PjijXbpcH7kazN5NyF_9`,
	"footer": `FmHwacSXUTcQJGwJhf9u`,
	"control": `wsLrdTGGFwgS0_wn9OoM`
};
export default ___CSS_LOADER_EXPORT___;
